<app-hero-image
  [title]="'Project Overview'"
  [imageUrl]="
    environment.cloudFrontUrl +
    '/content/project-overview/Project+Overview_1.jpg'
  "
></app-hero-image>
<div class="page-content-container">
  <div class="text-grid">
    <div class="text-container">
      <div class="text-content-1">
        <h2 style="margin-top: 0">Project Overview</h2>
        <p>
          The proposed I-24 Southeast Choice Lanes project would be the first
          Choice Lanes in Tennessee and aims to increase capacity and improve
          travel times for passenger and commercial vehicles along approximately
          26 miles of I-24 between I-40 south of downtown Nashville and I-840
          near Murfreesboro.
        </p>
      </div>

      <div class="text-content-2">
        <h2>Project Overview Video</h2>
        <p>
          Please watch this project overview video for background information
          and an explanation of Choice Lanes, Public Private Partnerships and
          transit benefits.
        </p>

        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/vy--nMdcrcI?si=YwRla1xUNIjd_IRB"
            title="I-24 Southeast Choice Lanes Project Overview"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[0].url"
      [title]="pdfDocuments[0].title"
      [thumbnailUrl]="pdfDocuments[0].thumbnail"
      [smallHeight]="true"
      containerId="adobe-dc-view-1"
    >
    </app-pdf-viewer>
  </div>

  <p>
    The Project Team held a series of public information meetings in August
    2024. Since then, we have been hard at work revising portions of the
    environmental review and making design refinements based on public and
    stakeholder feedback. Here's a quick highlight of what's changed since our
    last meetings.
  </p>

  <p>
    One of the biggest updates was to the Purpose & Need statement. The Purpose
    & Need is the foundation of any project and explains <em>why</em> the
    project is being proposed and <em>what</em> it is meant to accomplish. This
    serves as a guide for all project work, including design and helps us
    identify the best possible solution. The following exhibits below highlight
    what's changed since our last meetings.
  </p>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[1].url"
      [title]="pdfDocuments[1].title"
      [thumbnailUrl]="pdfDocuments[1].thumbnail"
      containerId="adobe-dc-view-2"
    >
    </app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[2].url"
      [title]="pdfDocuments[2].title"
      [thumbnailUrl]="pdfDocuments[2].thumbnail"
      containerId="adobe-dc-view-3"
    >
    </app-pdf-viewer>
  </div>

  <p style="margin-bottom: 1.5rem">Other changes include:</p>
  <ul class="list-container">
    <li class="list-item">
      <img
        src="assets/icons/hcv-icon.svg"
        alt=""
        class="list-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Evaluating heavy commercial vehicles (HCV) operating in the Choice Lanes
        to understand how that would impact traffic operations and any necessary
        changes to access ramps, interchanges or additional lane requirements.
      </span>
    </li>
    <li class="list-item">
      <img
        src="assets/icons/interchange-improvements-icon.svg"
        alt=""
        class="list-icon"
        aria-hidden="true"
      />
      <span class="list-text">
        Extending the base project to now extend the Choice Lanes south to I-840
        and interchange improvements at Almaville Road.
      </span>
    </li>
  </ul>

  <p>
    The next sections of the virtual meeting will focus on the environmental
    study, traffic data and design. We invite you to review this information and
    submit your thoughts on our public comment page. Your feedback is critical
    and will play a key role in identifying the best solution to address traffic
    congestion in this vital corridor.
  </p>

  <app-call-out-box
    [content]="
      '<p><strong>Still have questions?</strong></p><p>Here\'s a few FAQs to explain more about the project. <a href=\'https://www.tn.gov/content/dam/tn/tdot/region-3-documents/interstate-24-choice-lanes-/Choice%20Lanes%20FAQs_15.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>View our FAQ document</a> If you don\'t find it here, you can leave a question on our public comment page.</p>'
    "
  ></app-call-out-box>

  <div class="pdf-grid">
    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[3].url"
      [title]="pdfDocuments[3].title"
      [thumbnailUrl]="pdfDocuments[3].thumbnail"
      containerId="adobe-dc-view-4"
    >
    </app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[4].url"
      [title]="pdfDocuments[4].title"
      [thumbnailUrl]="pdfDocuments[4].thumbnail"
      containerId="adobe-dc-view-5"
    >
    </app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[5].url"
      [title]="pdfDocuments[5].title"
      [thumbnailUrl]="pdfDocuments[5].thumbnail"
      containerId="adobe-dc-view-6"
    >
    </app-pdf-viewer>

    <app-pdf-viewer
      [pdfUrl]="pdfDocuments[6].url"
      [title]="pdfDocuments[6].title"
      [thumbnailUrl]="pdfDocuments[6].thumbnail"
      containerId="adobe-dc-view-7"
    ></app-pdf-viewer>
  </div>
</div>
